import classNames from 'classnames'
import React from 'react'
import {Members} from '../../../members'
import {DescriptionProps} from './interfaces'
import s from './members.scss'

export const MobileCardMembers: React.FC<DescriptionProps> = ({event, visible, onClick}: DescriptionProps) =>
  visible ? (
    <div className={classNames(s.members)} data-hook="ev-list-item-members" onClick={onClick}>
      <Members event={event} listLayout />
    </div>
  ) : null
